'use client';

import React, {FC, useState} from 'react';
import {useRouter} from 'next/navigation';

import {renderUtils} from '@zoefin/design-system';

import {scoreFromFormData} from '../../scoring';
import ResultsView from '../../steps/StepUnlockResults/components/ResultsView';
import {readCompletedAnswers} from '../../store/storage';
import {firstNameFrom} from '../../utils';

const FORM_URL = '/financial-health-score';

// Standalone results entry point for `/financial-health-score?results`.
// Reads the completed snapshot from localStorage; if there isn't one, bumps
// the user back to the form URL.
const ResultsRoute: FC = () => {
  const {replace} = useRouter();
  const [formData] = useState(() => readCompletedAnswers());

  // If localStorage has no completed snapshot, bounce back to the form.
  // `router.replace` is a side effect (mutates history) so it can't run during
  // render — needs to fire post-mount.
  renderUtils.useMount(() => {
    if (!formData) {
      replace(FORM_URL);
    }
  });

  if (!formData) return null;

  const result = scoreFromFormData(formData);

  return (
    <ResultsView firstName={firstNameFrom(formData.fullName)} result={result} />
  );
};

export default ResultsRoute;
